import DatesheetPage from './DatesheetPage';
const AdminDatesheet = () => <DatesheetPage isAdmin={true} />;
export default AdminDatesheet;